import * as types from '@/store/mutation-types'

export default {
	namespaced: true,
	state: {
		invoiceCategories: [],
		defaultInvoiceCategories: [],
	},

	actions: {
		fetchAll({ commit }) {
			return window.axios.get('/MaterialFlow/CategoryInvoice'
			).then(response => {
				commit(types.STORE_INVOICE_CATEGORIES, response.data);
				return  response.data
			});
		},

		create(_, {
			name,
			notes,
			customerAccount,
			salesAccount,
			purchasesAccount,
			salesRefundAccount,
			purchasesRefundAccount,
			categoryInvoiceTypeRequests,
			isMaterialOnly
		}) {
			return window.axios.post('/MaterialFlow/CategoryInvoice', {
				name: name,
				notes: notes,
				customer_account_id: customerAccount,
				sales_account_id: salesAccount,
				purchases_account_id: purchasesAccount,
				sales_refund_account_id: salesRefundAccount,
				purchases_refund_account_id: purchasesRefundAccount,
				category_invoice_type_requests: categoryInvoiceTypeRequests,
				is_materials_only: isMaterialOnly
			}) .then(response => {
                return response.data;
            });
		},

		update(_, {
			id,
			name,
			notes,
			customerAccount,
			salesAccount,
			purchasesAccount,
			salesRefundAccount,
			purchasesRefundAccount,
			categoryInvoiceTypeRequests,
			isMaterialOnly
		}) {
			return window.axios.put(`/MaterialFlow/CategoryInvoice/${id}`, {
				name: name,
				notes: notes,
				customer_account_id: customerAccount,
				sales_account_id: salesAccount,
				purchases_account_id: purchasesAccount,
				sales_refund_account_id: salesRefundAccount,
				purchases_refund_account_id: purchasesRefundAccount,
				category_invoice_type_requests: categoryInvoiceTypeRequests,
				is_materials_only: isMaterialOnly
			})
		},

		delete(_, { id }) {
			return window.axios.delete(`/MaterialFlow/CategoryInvoice/${id}`)
		},

		fetchDefaultCategories({ commit }) {
			return window.axios.get('/MaterialFlow/CategoryInvoice/default').then(response => {
				commit(types.STORE_DEFAULT_INVOICES_CATEGORIES, response.data);
				return response.data;
			})
		},
		
		updateDefaultCategories(_, { defaultCategories }) {
			return window.axios.put('/MaterialFlow/CategoryInvoice/default', defaultCategories)
		},
	},

	mutations: {
		[types.STORE_INVOICE_CATEGORIES](state, invoiceCategories) {
			state.invoiceCategories = invoiceCategories
		},
		[types.STORE_DEFAULT_INVOICES_CATEGORIES](state, defaultInvoiceCategories) {
			state.defaultInvoiceCategories = defaultInvoiceCategories
		},
	},

	getters: {
		getInvoiceCategoryById: state => id => state.invoiceCategories.find(c => c.id === id)
	}
}